import { Injectable } from '@angular/core';
import { doc, Firestore, getDoc } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class InviteCodeService {

    constructor(
        private firestore: Firestore
    ) { }

    public async validateInviteCode(inviteCodeId: string | null): Promise<boolean | null> {
        try {
            if (!inviteCodeId) return true;
            const docExists = (await getDoc(doc(this.firestore, `inviteCodes/${inviteCodeId}`))).exists();
            return docExists;
        } catch(error) {
            console.error(error);
            return null;
        }
    }
}